<div class="grow grow--min grey-50-bg">
  <fin-check-in-subheader
    [bound]="bound$ | async"
    [locations]="locations$ | async"
    (exitCheckIn)="exitCheckIn()"
    (viewFlightDetails)="viewFlightDetailsOpen$.next(true)"
  >
  </fin-check-in-subheader>
  <div class="grid-max-width center grid-col-12 no-row-gap ng-star-inserted">
    <div class="col-f md-col-3-10 xl-col-4-9">
      <div *ngIf="showNavigateBackButton$ | async" class="flex font-body-1 pr-small-t">
        <fcom-button
          data-testid="check-in-navigate-back-button"
          class="back-button"
          [attr.title]="'actions.back' | finLocalization"
          [icon]="{
            name: SvgLibraryIcon.CHEVRON_LEFT,

            position: IconPosition.LEFT,
          }"
          [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
          [text]="'MMB.checkIn.funnel.actions.navigateBack' | finLocalization"
          (clickBtn)="navigateBack()"
        >
        </fcom-button>
      </div>
      <div *ngIf="(currentStep$ | async) !== CheckInStep.CONFIRMATION" class="flex flex--space-between flex--middle">
        <h1 data-testid="page-title" class="ps-large-y ps-large-r font-heading-3">
          {{ pageTitle$ | async | finLocalization }}
        </h1>
        <fcom-stepper
          [activeStep]="currentStepNumber$ | async"
          [steps]="stepperSteps$ | async"
          [mode]="StepperMode.RADIAL"
        >
        </fcom-stepper>
      </div>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<fcom-modal
  data-testid="itinerary-timeline-modal"
  [open]="viewFlightDetailsOpen$ | async"
  (close)="viewFlightDetailsOpen$.next(false)"
  (openChange)="viewFlightDetailsOpen$.next(true)"
  [title]="'MMB.view.itineraryModal.title' | finLocalization"
  [buttons]="ModalButtons.DONE"
  [shouldAddPaddingTop]="isInsideApp"
>
  <fin-itinerary-timeline
    [bound]="bound$ | async"
    [locations]="locations$ | async"
    [boundType]="BoundType.outbound"
    class="block pr-medium"
  >
  </fin-itinerary-timeline>
</fcom-modal>

<fcom-modal
  [open]="closeSeatChangesModalOpen$ | async"
  [fitToContent]="true"
  [buttons]="ModalButtons.CONTINUE_CANCEL"
  [title]="'MMB.checkIn.steps.seats.modal.exit.title' | finLocalization"
  (close)="closeSeatChangesModalOpen$.next(false)"
  (confirm)="showSeatChangesModalOrNavigateBack(true)"
  [shouldAddPaddingTop]="isInsideApp"
>
  <p class="pr-large font-body-1">
    {{ 'MMB.checkIn.steps.seats.modal.exit.content' | finLocalization }}
  </p>
</fcom-modal>

<div *ngIf="showExitRowSeatsNotification$ | async">
  <fin-check-in-exit-row-seats
    [exitRowSeats]="exitRowSeatsToConfirm$ | async"
    (confirmExitRowSeats)="onConfirmExitRowSeats($event)"
  >
  </fin-check-in-exit-row-seats>
</div>

<div *ngIf="reassigningSeatsModalLoader$ | async">
  <fcom-modal
    [fitToContent]="true"
    [forceRemainOpen]="true"
    [open]="true"
    [title]="'MMB.checkIn.review.titles.reassigningSeats' | finLocalization"
    [buttons]="null"
    [shouldAddPaddingTop]="isInsideApp"
  >
    <fin-loader
      aria-live="polite"
      [hideTitle]="true"
      [type]="LoaderType.EMBEDDED"
      [waitingFor]="'MMB.checkIn.review.reassigningSeats'"
    ></fin-loader>
  </fcom-modal>
</div>
